import { Text, Stack, Grid, Row, Col } from "rsuite";
import { useSelector } from "react-redux";
import { selectConfigExpressTaxHidePropertyOccupancySection, selectConfigExpressTaxTaxableReceiptsLabel } from "../../../store/slices/config/configSelectors";
import { convertNumberToCurrency } from "../../../common/utils";
import React, { useMemo } from "react";
import ReportedLicensePeriodItem from "./ReportedLicensePeriodData";

const ReportedLicensePeriodHeader = ({ licensePeriod }) => {
  const taxableReceiptsLabel = useSelector(selectConfigExpressTaxTaxableReceiptsLabel);
  const hidePropertyOccupanySection = useSelector(selectConfigExpressTaxHidePropertyOccupancySection);

  const lgWidth = useMemo(() => {
    // grid has 24 columns
    // If property occupanct section is disbaled we have 4 fields otherwise we have 6
    return hidePropertyOccupanySection ? 24 / 4 : 24 / 6;
  }, [hidePropertyOccupanySection])

  const paymentStatus = useMemo(() => {
    const paymentSuccessful = licensePeriod.paymentSuccessful;
    const paymentPending = licensePeriod.isPending;

    if (paymentPending) {
      return '(Pending)'
    }
    else if (!paymentSuccessful) {
      return '(Failed)'
    }
    else {
      return '';
    }
  }, [licensePeriod])

  return (
    <Grid className="reporting-history-item-header">
      <Row style={{ display: 'flex', alignItems: 'stretch', flexWrap: 'wrap' }}>
        <Col xs={24} lg={lgWidth}>
          <div role="grid">
            <Row>
              <Col xs={12} lg={24} className="mb-8">
                <Text className="text-large text-bold text-left-lg">{licensePeriod.label}</Text>
              </Col>
              <Col xs={12} lg={24} className="pb-lg-lower-8">
                <Stack className="text-left-lg" direction="column" style={{ height: '100%', justifyContent: 'space-between' }}>
                  <Stack.Item className="full-width">
                    <Text>{`Reported ${licensePeriod.reportedDate}`}</Text>
                  </Stack.Item>
                  <Stack.Item className="full-width">
                    <Text>{`by ${licensePeriod.reportedBy}`}</Text>
                  </Stack.Item>
                </Stack>
              </Col>
            </Row>
          </div>
        </Col>
        {
          !hidePropertyOccupanySection && (
            <>
              <Col xs={12} lg={lgWidth} className="pb-lg-lower-8">
                <ReportedLicensePeriodItem label='Days Available' value={licensePeriod.daysAvailable} />
              </Col>
              <Col xs={12} lg={lgWidth} className="pb-lg-lower-8">
                <ReportedLicensePeriodItem label='Days Occupied' value={licensePeriod.daysOccupied} />
              </Col>
            </>
          )
        }
        <Col xs={12} lg={lgWidth} className="pb-lg-lower-8">
          <ReportedLicensePeriodItem label={`Total ${taxableReceiptsLabel}`} value={convertNumberToCurrency(licensePeriod.totalTaxableReceipts)} />
        </Col>
        <Col xs={12} lg={lgWidth} className="pb-lg-lower-8">
          <ReportedLicensePeriodItem label='Payment' value={convertNumberToCurrency(licensePeriod.paymentAmount)} />
        </Col>
        <Col xs={12} lg={lgWidth} className="pb-lg-lower-8">
          <ReportedLicensePeriodItem label='Paid by' value={`${licensePeriod.paidBy} ${paymentStatus}`} />
        </Col>
      </Row>
    </Grid>
  );
};

export default ReportedLicensePeriodHeader; 
